import React from 'react'

interface Props {
  size?: number
  className?: string
}

export const LovableIcon: React.FC<Props> = ({ size = 18, className }) => (
  <img
    src='/media/tfi/lovable-icon.jpeg'
    alt='Lovable'
    className={className}
    style={{ width: size, height: size, objectFit: 'contain', borderRadius: 4 }}
  />
)
